// libraries.
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// slices.
import { setDefaultState } from "@domains/VIM/slices/vim.slice";

// types.
import { pathHome } from "@routes/routes.types";
import { pathHomeInventoryList } from "@pages/HomePage/routes/routes.types";

export const useHandleSuccess = (isSuccess: boolean, isError: boolean) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess) {
      navigate(`${pathHome}/${pathHomeInventoryList}`);
      toast.success("Precios guardados correctamente");
      dispatch(setDefaultState());
    }
    if (isError) {
      toast.error(
        <small>
          <strong>No se pudo actualizar el precio.</strong>{" "}
          <small>
            Verifica el estado del inmueble o comunícate con soporte.
          </small>
        </small>,
      );
    }
  }, [isSuccess, isError]);
};
